// extracted by mini-css-extract-plugin
export default {"grid":"ListingCard_grid__A4QJO","image":"ListingCard_image__m-nWs","agencyLogo":"ListingCard_agencyLogo__Z0I3T","details":"ListingCard_details__guUUm"};